<template>
  <div class="Kanit BGwhite">
    <v-card-text style="margin-top:0vh; margin-bottom:0vh; justify-content: center !important; color: rgb(74, 74, 74) !important;">
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex sm12 md12 lg12 xl12 style="display: flex; justify-content: center; margin-top: -4vh;">
            <v-container grid-list-md class="mt-2">
              <v-layout wrap>
                <v-flex sm12 md12 lg12 xl12>
                  <v-btn icon flat @click="backlink()">
                    <v-icon>navigate_before</v-icon>
                  </v-btn>
                  <h2 class="headerColor">กำหนดเมนู</h2>
                  <v-flex xs12 sm12 md12 lg12 x12 class="mt-1" style=" text-align:center;">
                    <v-container style="padding: 0px !important;">
                      <v-flex sm12 md12 lg12 xl12>
                        <v-layout wrap xs8 sm8 md8 xl8 lg8>
                          <strong class="labelAssignMenu">ชื่อ : </strong>
                          <v-flex xs8 sm8 md8 lg8 xl8>
                            <v-text-field single-line v-model="name" :counter="30" maxlength="30" required :rules="nameRules"></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <strong style="padding-top: 0px;" class="labelAssignMenu">สถานะ : </strong>
                          <v-radio-group v-model="statusRichMenu" :mandatory="false" row style="margin-top: 0px !important;">
                            <v-radio label="เปิด" value="1"></v-radio>
                            <v-radio label="ปิด" value="0"></v-radio>
                          </v-radio-group>
                        </v-layout>
                        <v-layout row wrap>
                          <strong style="padding-top: 0px;" class="labelAssignMenu">ข้อความ Bottom menu : </strong>
                          <v-radio-group v-model="bottomMenu" :mandatory="false" row style="margin-top: 0px !important;max-width: 205px;">
                            <v-radio label="Menu" value="default"></v-radio>
                            <v-radio label="โปรดระบุ :" value="designame"></v-radio>
                          </v-radio-group>
                          <v-text-field :counter="14" maxlength="14" :rules="nameBottomRule" :disabled="(bottomMenu == 'default')" v-model="nameBottom" required style="margin-top: 0px !important; padding-top: 0px !important;"></v-text-field>
                        </v-layout>
                        <v-layout>
                          <strong style="padding-top: 0px;" class="labelAssignMenu">การแสดงเมนูเริ่มต้น :</strong>
                          <v-radio-group v-model="showBasicMenu" :mandatory="false" row style="margin-top: 0px !important;">
                            <v-radio label="แสดง" value="1"></v-radio>
                            <v-radio label="ซ่อน" value="0"></v-radio>
                          </v-radio-group>
                        </v-layout>
                      </v-flex>
                    </v-container>
                  </v-flex>
                  <v-divider style="border-color: #2562af !important;"></v-divider>
                  <h2 class="headerColor">สร้าง Bottom Menu</h2>
                  <v-flex xs12 sm12 md12 lg12 x12 class="mt-1" style="text-align:center; padding-top: 30px;padding-bottom: 20px;">
                    <input ref="fileInput" type="file" @input="onSelectfile" style="display:none">
                    <input ref="fileInput2" type="file" @input="onSelectfile2" style="display:none">
                    <input ref="fileInput3" type="file" @input="onSelectfile3" style="display:none">
                    <input ref="fileInput4" type="file" @input="onSelectfile4" style="display:none">
                    <input ref="fileInput5" type="file" @input="onSelectfile5" style="display:none">
                    <input ref="fileInput6" type="file" @input="onSelectfile6" style="display:none">
                    <div>
                      <v-layout wrap row>
                        <v-flex xs8 sm8 md8 lg8 x8>
                          <div v-if="template==1">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width: 125px;  border: 1px solid black; cursor:pointer" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div style="height: 125px;width: 125px;background: #f0f0f0; border: 1px solid black;  cursor:pointer;" @click="chooseImage2" class="divTextCenter">
                                <v-img v-if="url2" :src="url2" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">B</div>
                              </div>
                              <div style="height: 125px;width: 125px;background: #f0f0f0; border: 1px solid black; cursor:pointer;" @click="chooseImage3" class="divTextCenter">
                                <v-img v-if="url3" :src="url3" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">C</div>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex;padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width: 125px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage4" class="divTextCenter">
                                <v-img v-if="url4" :src="url4" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">D</div>
                              </div>
                              <div style="height: 125px;width: 125px;background: #f0f0f0; border: 1px solid black;  cursor:pointer;" @click="chooseImage5" class="divTextCenter">
                                <v-img v-if="url5" :src="url5" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">E</div>
                              </div>
                              <div style="height: 125px;width: 125px;background: #f0f0f0; border: 1px solid black;  cursor:pointer;" @click="chooseImage6" class="divTextCenter">
                                <v-img v-if="url6" :src="url6" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">F</div>
                              </div>
                            </v-flex>
                          </div>
                          <div v-else-if="template==2">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width: 187.5px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div style="height: 125px;width: 187.5px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage2" class="divTextCenter">
                                <v-img v-if="url2" :src="url2" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">B</div>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex;padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width: 187.5px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage3" class="divTextCenter">
                                <v-img v-if="url3" :src="url3" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">C</div>
                              </div>
                              <div style="height: 125px;width: 187.5px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage4" class="divTextCenter">
                                <v-img v-if="url4" :src="url4" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">D</div>
                              </div>
                            </v-flex>
                          </div>
                          <div v-else-if="template==3">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width: 375px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex;padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width: 125px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage2" class="divTextCenter">
                                <v-img v-if="url2" :src="url2" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">B</div>
                              </div>
                              <div style="height: 125px;width: 125px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage3" class="divTextCenter">
                                <v-img v-if="url3" :src="url3" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">C</div>
                              </div>
                              <div style="height: 125px;width: 125px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage4" class="divTextCenter">
                                <v-img v-if="url4" :src="url4" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">D</div>
                              </div>
                            </v-flex>
                          </div>
                          <div v-else-if="template==4">
                            <v-layout wrap>
                              <v-flex style="display: flex; padding: 0 !important;justify-content: flex-end;">
                                <div style="height: 250px; width: 250px; background: #f0f0f0; border: 1px solid black; cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                  <v-img v-if="url" :src="url" max-height="250" aspect-ratio="1" cover />
                                  <div class="TextCenterPicture">A</div>
                                </div>
                              </v-flex>
                              <v-flex style="display: flex; padding: 0 !important;justify-content: center;">
                                <v-layout wrap style="justify-content: end;">
                                  <v-flex>
                                    <div style="height: 125px; width: 125px; background: #f0f0f0; border: 1px solid black; cursor:pointer;" @click="chooseImage2" class="divTextCenter">
                                      <v-img v-if="url2" :src="url2" max-height="125" aspect-ratio="1" cover />
                                      <div class="TextCenterPicture">B</div>
                                    </div>
                                    <div style="height: 125px; width: 125px; background: #f0f0f0; border: 1px solid black; cursor:pointer;" @click="chooseImage3" class="divTextCenter">
                                      <v-img v-if="url3" :src="url3" max-height="125" aspect-ratio="1" cover />
                                      <div class="TextCenterPicture">C</div>
                                    </div>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </div>
                          <div v-else-if="template==5">
                            <v-flex xs12 sm12 md12 xl12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 125px; width: 375px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" max-height="125" min-width="375" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                            </v-flex>
                            <v-flex style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width: 375px; background: #f0f0f0; border: 1px solid black; cursor:pointer;" @click="chooseImage2" class="divTextCenter">
                                <v-img v-if="url2" :src="url2" max-height="125" min-width="375" aspect-ratio="2" cover />
                                <div class="TextCenterPicture">B</div>
                              </div>
                            </v-flex>
                          </div>
                          <div v-else-if="template==6">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 250px;width: 187.5px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" max-height="250" min-width="187.5" min-height="250" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div style="height: 250px;width: 187.5px; background: #f0f0f0; border: 1px solid black; cursor:pointer;" @click="chooseImage2" class="divTextCenter">
                                <v-img v-if="url2" :src="url2" max-height="250" min-width="187.5" min-height="250" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">B</div>
                              </div>
                            </v-flex>
                          </div>
                          <div v-else-if="template==7">
                            <v-flex s12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 250px;width:375px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" max-height="250" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                            </v-flex>
                          </div>
                          <div v-else-if="template==8">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width:125px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div style="height: 125px;width:125px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage2" class="divTextCenter">
                                <v-img v-if="url2" :src="url2" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">B</div>
                              </div>
                              <div style="height: 125px;width:125px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage3" class="divTextCenter">
                                <v-img v-if="url3" :src="url3" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">C</div>
                              </div>
                            </v-flex>
                          </div>
                          <div v-else-if="template==9">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width:125px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div style="height: 125px;width:250px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage2" class="divTextCenter">
                                <v-img v-if="url2" :src="url2" max-width="250" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">B</div>
                              </div>
                            </v-flex>
                          </div>
                          <div v-else-if="template==10">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width:250px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" max-width="250" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div style="height: 125px;width:125px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage2" class="divTextCenter">
                                <v-img v-if="url2" :src="url2" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">B</div>
                              </div>
                            </v-flex>
                          </div>
                          <div v-else-if="template==11">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width:187.5px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" max-width="187.5" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div style="height: 125px;width:187.5px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage2" class="divTextCenter">
                                <v-img v-if="url2" :src="url2" max-width="187.5" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">B</div>
                              </div>
                            </v-flex>
                          </div>
                          <div v-else-if="template==12">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 125px;width:375px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" max-width="375" max-height="125" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                            </v-flex>
                          </div>
                          <div v-else-if="template==13">
                            <v-flex xs12 sm12 md12 lg12 x12 style="display: flex; padding: 0 !important;justify-content: center;">
                              <div style="height: 93.8px;width:93.8px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage" class="divTextCenter">
                                <v-img v-if="url" :src="url" max-height="282" max-width="282" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">A</div>
                              </div>
                              <div style="height: 93.8px;width:93.8px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage2" class="divTextCenter">
                                <v-img v-if="url2" :src="url2" max-height="282" max-width="282" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">B</div>
                              </div>
                              <div style="height: 93.8px;width:93.8px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage3" class="divTextCenter">
                                <v-img v-if="url3" :src="url3" max-height="282" max-width="282" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">C</div>
                              </div>
                              <div style="height: 93.8px;width:93.8px; background: #f0f0f0; border: 1px solid black;cursor:pointer;" @click="chooseImage4" class="divTextCenter">
                                <v-img v-if="url4" :src="url4" max-height="282" max-width="282" aspect-ratio="1" cover />
                                <div class="TextCenterPicture">D</div>
                              </div>
                            </v-flex>
                          </div>
                          <!-- ----------------- -->
                          <v-flex xs12 sm12 md12 lg12 x12 style="display: flex !important;justify-content: center; padding-top: 0px;">
                            <div style="height: 45px;width: 375px; background: white; border: 1px solid black;">
                              <v-layout>
                                <v-flex xs2 sm2 md2 xl2 style="padding-top: 10px; padding-bottom:25px">
                                  <i class="fas fa-keyboard fa-2x" style="padding-right: 4px;"></i>
                                  <v-divider vertical></v-divider>
                                </v-flex>
                                <v-flex xs10 sm10 md10 xl10 style="padding-right:60px">
                                  <i class="fas fa-caret-down" style="display: inline;"></i>
                                  <p style="padding-top:-2px">{{nameBottom}}</p>
                                </v-flex>
                                <v-divider></v-divider>
                              </v-layout>
                            </div>
                          </v-flex>
                        </v-flex>
                        <v-flex xs4 sm4 md4 lg4 x4 style="text-align: left;">
                          <div style="height: 100%;">
                            <v-btn @click="selectTemplate()" style="margin-top: -15px !important;" class="vertical_center btnTemplate">เลือก เทมเพลต</v-btn>
                            <br>
                            <v-btn @click="createBottomMenu()" :disabled="disabledBtnCreate()" style="margin-top: 15px !important;" class="vertical_center btnTemplate">สร้าง</v-btn>
                          </div>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                  <v-divider style="border-color: #2562af !important;"></v-divider>
                  <h2 class="headerColor">แอ็คชัน</h2>
                  <v-layout wrap row>
                    <v-flex xs1 sm1 md1 lg1 x1></v-flex>
                    <v-flex xs10 sm10 md10 lg10 x10 class="mt-1" style="text-align:center; padding-top: 10px;">
                      <div style="margin-top:20px">
                        <v-layout row wrap class="actionTemplate">
                          <v-flex xs1 sm1 md1 lg1 x1>
                            <h3>A</h3>
                          </v-flex>
                          <span class="spanStyle">รูปแบบ :</span>
                          <v-flex xs8 sm8 md8 lg8 x8>
                            <v-select class="Kanit" :items="type_menu" v-model="type"></v-select>
                            <div v-if="type==='link' || type==='link_market'">
                              <v-text-field single-line v-model="urlLink" label="URL" style="padding-top: 0px !important;"></v-text-field>
                              <v-layout v-if="type==='link'">
                                <span style="margin-top:10px; margin-right:10px">ต้องการข้อมูลผู้ใช้งาน :</span>
                                <v-radio-group v-model="profile" row style="margin-top: 5px !important;">
                                  <v-radio label="ต้องการ" value="true"></v-radio>
                                  <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                </v-radio-group>
                              </v-layout>
                              <v-layout v-if="profile === 'true'" class="typeProfile">
                                <span style="margin: auto; margin-right:10px; font-size:14px;">ประเภทข้อมูล :</span>
                                <v-radio-group v-model="signtype" row>
                                  <v-radio value="sign_share" label="share token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken = true;"></i>
                                  <v-radio value="sign" label="onechat_token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true;"></i>
                                </v-radio-group>
                              </v-layout>
                            </div>
                            <div v-else-if="type==='webview'">
                              <v-text-field single-line v-model="urlLink" label="URL" style="padding-top: 0px !important;"></v-text-field>
                              <v-layout>
                                <span style="margin-top:10px; margin-right:10px">ต้องการข้อมูลผู้ใช้งาน :</span>
                                <v-radio-group v-model="profile" row style="margin-top: 0px !important;">
                                  <v-radio label="ต้องการ" value="true"></v-radio>
                                  <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                </v-radio-group>
                              </v-layout>
                              <v-layout v-if="profile === 'true'" class="typeProfile">
                                <span style="margin: auto; margin-right:10px; font-size:14px;">ประเภทข้อมูล :</span>
                                <v-radio-group v-model="signtype" row>
                                  <v-radio value="sign_share" label="share token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken = true"></i>
                                  <v-radio value="sign" label="onechat_token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true"></i>
                                </v-radio-group>
                              </v-layout>
                              <v-layout>
                                <span style="margin-top:10px; margin-right:10px">ขนาดแสดงผล :</span>
                                <i class="fas fa-info-circle iconSizeWebview" @click="dialogSizeWebviewExample = true"></i>
                                <v-radio-group v-model="showSize" row style="margin-top: 5px !important;">
                                  <v-radio label="Compact" value="compact"></v-radio>
                                  <v-radio label="Tall" value="tall"></v-radio>
                                  <v-radio label="Full" value="full"></v-radio>
                                </v-radio-group>
                              </v-layout>
                            </div>
                            <div v-else-if="type==='text'">
                              <v-text-field single-line v-model="text" :counter="50" maxlength="50" label="ข้อความ" style="padding-top: 0px !important;margin-bottom: 10px;"></v-text-field>
                            </div>
                            <div v-else-if="type==='location'">
                              <v-layout class="pb-3">
                                <span style="text-align:left; color:red; font-size:12px;">*</span>
                                &nbsp;
                                <span style="text-align:left; color:grey; font-size:12px;"> ระบบจะดึงตำแหน่งที่ตั้งปัจจุบันของผู้ใช้งานไปแสดงในห้องแชทเมื่อมีการเรียกใช้งาน Bottom Menu ประเภทโลเคชัน</span>
                              </v-layout>
                            </div>
                            <div v-else-if="type==='qrcode'">
                              <v-layout>
                                <span style="margin-top:10px; margin-right:10px">ต้องการโลเคชัน :</span>
                                <v-radio-group hide-details v-model="location" row style="margin-top: 5px !important;">
                                  <v-radio label="ต้องการ" value="true"></v-radio>
                                  <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                </v-radio-group>
                              </v-layout>
                              <v-layout class="pt-2">
                                <span style="text-align:left; color:red; font-size:12px;">*</span>
                                &nbsp;
                                <span style="text-align:left; color:grey; font-size:12px;">ใช้สำหรับการเปิดตัวอ่านคิวอาร์โค้ด</span>
                              </v-layout>
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap class="actionTemplate" v-if="templateDetail[template-1] >= 2">
                          <v-flex xs1 sm1 md1 lg1 x1>
                            <h3>B</h3>
                          </v-flex>
                          <span class="spanStyle">รูปแบบ :</span>
                          <v-flex xs8 sm8 md8 lg8 x8>
                            <v-select :items="type_menu" v-model="type2"></v-select>
                            <div v-if="type2==='link' || type2==='link_market'">
                              <v-text-field single-line v-model="urlLink2" label="URL" style="padding-top: 0px !important;"></v-text-field>
                              <v-layout v-if="type2==='link'">
                                <span style="margin-top:10px; margin-right:10px">ต้องการข้อมูลผู้ใช้งาน :</span>
                                <!-- <i class="fas fa-info-circle iconSizeWebview" @click="dialoggetProfile = true"></i> -->
                                <v-radio-group v-model="profile2" row style="margin-top: 5px !important;">
                                  <v-radio label="ต้องการ" value="true"></v-radio>
                                  <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                </v-radio-group>
                              </v-layout>
                              <!-- ถ้าเลือกต้องการ -->
                              <v-layout v-if="profile2 === 'true'" class="typeProfile">
                                <span style="margin: auto; font-size:14px; margin-right:10px">ประเภทข้อมูล :</span>
                                <v-radio-group v-model="signtype2" row>
                                  <v-radio value="sign_share" label="share token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken= true"></i>
                                  <v-radio value="sign" label="onechat_token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true"></i>
                                </v-radio-group>
                              </v-layout>
                              <!--  -->
                            </div>
                            <div v-else-if="type2==='webview'">
                              <v-text-field single-line v-model="urlLink2" label="URL" style="padding-top: 0px !important;"></v-text-field>
                              <v-layout>
                                <span style="margin-top:10px; margin-right:10px">ต้องการข้อมูลผู้ใช้งาน :</span>
                                <!-- <i class="fas fa-info-circle iconSizeWebview" @click="dialoggetProfile = true"></i> -->
                                <v-radio-group v-model="profile2" row style="margin-top: 5px !important;">
                                  <v-radio label="ต้องการ" value="true"></v-radio>
                                  <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                </v-radio-group>
                              </v-layout>
                              <!-- ถ้าเลือกต้องการ -->
                              <v-layout v-if="profile2 === 'true'" class="typeProfile">
                                <span style="margin: auto; font-size:14px; margin-right:10px">ประเภทข้อมูล :</span>
                                <v-radio-group v-model="signtype2" row>
                                  <v-radio value="sign_share" label="share token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken= true"></i>
                                  <v-radio value="sign" label="onechat_token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true"></i>
                                </v-radio-group>
                              </v-layout>
                              <!--  -->
                              <v-layout>
                                <span style="margin-top:10px; margin-right:10px">ขนาดแสดงผล :</span>
                                <i class="fas fa-info-circle iconSizeWebview" @click="dialogSizeWebviewExample = true"></i>
                                <v-radio-group v-model="showSize2" row style="margin-top: 5px !important;">
                                  <v-radio label="Compact" value="compact"></v-radio>
                                  <v-radio label="Tall" value="tall"></v-radio>
                                  <v-radio label="Full" value="full"></v-radio>
                                </v-radio-group>
                              </v-layout>
                            </div>
                            <div v-else-if="type2==='text'">
                              <v-text-field single-line v-model="text2" :counter="50" maxlength="50" label="ข้อความ" style="padding-top: 0px !important;margin-bottom: 10px;"></v-text-field>
                            </div>
                            <div v-else-if="type2==='location'">
                              <v-layout class="pb-3">
                                <span style="text-align:left; color:red; font-size:12px;">*</span>
                                &nbsp;
                                <span style="text-align:left; color:grey; font-size:12px;"> ระบบจะดึงตำแหน่งที่ตั้งปัจจุบันของผู้ใช้งานไปแสดงในห้องแชทเมื่อมีการเรียกใช้งาน Bottom Menu ประเภทโลเคชัน</span>
                              </v-layout>
                            </div>
                            <div v-else-if="type2==='qrcode'">
                              <v-layout>
                                <span style="margin-top:10px; margin-right:10px">ต้องการโลเคชัน :</span>
                                <v-radio-group v-model="location2" hide-details row style="margin-top: 5px !important;">
                                  <v-radio label="ต้องการ" value="true"></v-radio>
                                  <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                </v-radio-group>
                              </v-layout>
                              <v-layout class="pt-2">
                                <span style="text-align:left; color:red; font-size:12px;">*</span>
                                &nbsp;
                                <span style="text-align:left; color:grey; font-size:12px;">ใช้สำหรับการเปิดตัวอ่านคิวอาร์โค้ด</span>
                              </v-layout>
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap class="actionTemplate" v-if="templateDetail[template-1] >= 3">
                          <v-flex xs1 sm1 md1 lg1 x1>
                            <h3>C</h3>
                          </v-flex>
                          <span class="spanStyle">รูปแบบ :</span>
                          <v-flex xs8 sm8 md8 lg8 x8>
                            <v-select :items="type_menu" v-model="type3"></v-select>
                            <div v-if="type3==='link' || type3==='link_market'">
                              <v-text-field single-line v-model="urlLink3" label="URL" style="padding-top: 0px !important;"></v-text-field>
                              <v-layout v-if="type3==='link'">
                                <span style="margin-top:10px; margin-right:10px">ต้องการข้อมูลผู้ใช้งาน :</span>
                                <!-- <i class="fas fa-info-circle iconSizeWebview" @click="dialoggetProfile = true"></i> -->
                                <v-radio-group v-model="profile3" row style="margin-top: 5px !important;">
                                  <v-radio label="ต้องการ" value="true"></v-radio>
                                  <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                </v-radio-group>
                              </v-layout>
                              <!-- ถ้าเลือกต้องการ -->
                              <v-layout v-if="profile3 === 'true'" class="typeProfile">
                                <span style="margin: auto; font-size:14px; margin-right:10px">ประเภทข้อมูล :</span>
                                <v-radio-group v-model="signtype3" row>
                                  <v-radio value="sign_share" label="share token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken= true"></i>
                                  <v-radio value="sign" label="onechat_token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true"></i>
                                </v-radio-group>
                              </v-layout>
                              <!--  -->
                            </div>
                            <div v-else-if="type3==='webview'">
                              <v-text-field single-line v-model="urlLink3" label="URL" style="padding-top: 0px !important;"></v-text-field>
                              <v-layout>
                                <span style="margin-top:10px; margin-right:10px">ต้องการข้อมูลผู้ใช้งาน :</span>
                                <!-- <i class="fas fa-info-circle iconSizeWebview" @click="dialoggetProfile = true"></i> -->
                                <v-radio-group v-model="profile3" row style="margin-top: 5px !important;">
                                  <v-radio label="ต้องการ" value="true"></v-radio>
                                  <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                </v-radio-group>
                              </v-layout>
                              <!-- ถ้าเลือกต้องการ -->
                              <v-layout v-if="profile3 === 'true'" class="typeProfile">
                                <span style="margin: auto; font-size:14px; margin-right:10px">ประเภทข้อมูล :</span>
                                <v-radio-group v-model="signtype3" row>
                                  <v-radio value="sign_share" label="share token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken= true"></i>
                                  <v-radio value="sign" label="onechat_token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true"></i>
                                </v-radio-group>
                              </v-layout>
                              <!--  -->
                              <v-layout>
                                <span style="margin-top:10px; margin-right:10px">ขนาดแสดงผล :</span>
                                <i class="fas fa-info-circle iconSizeWebview" @click="dialogSizeWebviewExample = true"></i>
                                <v-radio-group v-model="showSize3" row style="margin-top: 5px !important;">
                                  <v-radio label="Compact" value="compact"></v-radio>
                                  <v-radio label="Tall" value="tall"></v-radio>
                                  <v-radio label="Full" value="full"></v-radio>
                                </v-radio-group>
                              </v-layout>
                            </div>
                            <div v-else-if="type3 === 'text'">
                              <v-text-field single-line v-model="text3" :counter="50" maxlength="50" label="ข้อความ" style="padding-top: 0px !important;margin-bottom: 10px;"></v-text-field>
                            </div>
                            <div v-else-if="type3==='location'">
                              <v-layout class="pb-3">
                                <span style="text-align:left; color:red; font-size:12px;">*</span>
                                &nbsp;
                                <span style="text-align:left; color:grey; font-size:12px;"> ระบบจะดึงตำแหน่งที่ตั้งปัจจุบันของผู้ใช้งานไปแสดงในห้องแชทเมื่อมีการเรียกใช้งาน Bottom Menu ประเภทโลเคชัน</span>
                              </v-layout>
                            </div>
                            <div v-else-if="type3==='qrcode'">
                              <v-layout>
                                <span style="margin-top:10px; margin-right:10px">ต้องการโลเคชัน :</span>
                                <v-radio-group hide-details v-model="location3" row style="margin-top: 5px !important;">
                                  <v-radio label="ต้องการ" value="true"></v-radio>
                                  <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                </v-radio-group>
                              </v-layout>
                              <v-layout class="pt-2">
                                <span style="text-align:left; color:red; font-size:12px;">*</span>
                                &nbsp;
                                <span style="text-align:left; color:grey; font-size:12px;">ใช้สำหรับการเปิดตัวอ่านคิวอาร์โค้ด</span>
                              </v-layout>
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap class="actionTemplate" v-if="templateDetail[template-1] >= 4">
                          <v-flex xs1 sm1 md1 lg1 x1>
                            <h3>D</h3>
                          </v-flex>
                          <span class="spanStyle">รูปแบบ :</span>
                          <v-flex xs8 sm8 md8 lg8 x8>
                            <v-select :items="type_menu" v-model="type4"></v-select>
                            <div v-if="type4==='link' || type4==='link_market'">
                              <v-text-field single-line v-model="urlLink4" label="URL" style="padding-top: 0px !important;"></v-text-field>
                              <v-layout v-if="type4==='link'">
                                <span style="margin-top:10px; margin-right:10px">ต้องการข้อมูลผู้ใช้งาน :</span>
                                <!-- <i class="fas fa-info-circle iconSizeWebview" @click="dialoggetProfile = true"></i> -->
                                <v-radio-group v-model="profile4" row style="margin-top: 5px !important;">
                                  <v-radio label="ต้องการ" value="true"></v-radio>
                                  <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                </v-radio-group>
                              </v-layout>
                              <!-- ถ้าเลือกต้องการ -->
                              <v-layout v-if="profile4 === 'true'" class="typeProfile">
                                <span style="margin: auto; font-size:14px; margin-right:10px">ประเภทข้อมูล :</span>
                                <v-radio-group v-model="signtype4" row>
                                  <v-radio value="sign_share" label="share token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken= true"></i>
                                  <v-radio value="sign" label="onechat_token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true"></i>
                                </v-radio-group>
                              </v-layout>
                              <!--  -->
                            </div>
                            <div v-else-if="type4==='webview'">
                              <v-text-field single-line v-model="urlLink4" label="URL" style="padding-top: 0px !important;"></v-text-field>
                              <v-layout>
                                <span style="margin-top:10px; margin-right:10px">ต้องการข้อมูลผู้ใช้งาน :</span>
                                <i class="fas fa-info-circle iconSizeWebview" @click="dialoggetProfile = true"></i>
                                <v-radio-group v-model="profile4" row style="margin-top: 5px !important;">
                                  <v-radio label="ต้องการ" value="true"></v-radio>
                                  <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                </v-radio-group>
                              </v-layout>
                              <!-- ถ้าเลือกต้องการ -->
                              <v-layout v-if="profile4 === 'true'" class="typeProfile">
                                <span style="margin: auto; font-size:14px; margin-right:10px">ประเภทข้อมูล :</span>
                                <v-radio-group v-model="signtype4" row>
                                  <v-radio value="sign_share" label="share token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken= true"></i>
                                  <v-radio value="sign" label="onechat_token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true"></i>
                                </v-radio-group>
                              </v-layout>
                              <!--  -->
                              <v-layout>
                                <span style="margin-top:10px; margin-right:10px">ขนาดแสดงผล :</span>
                                <i class="fas fa-info-circle iconSizeWebview" @click="dialogSizeWebviewExample = true"></i>
                                <v-radio-group v-model="showSize4" row style="margin-top: 5px !important;">
                                  <v-radio label="Compact" value="compact"></v-radio>
                                  <v-radio label="Tall" value="tall"></v-radio>
                                  <v-radio label="Full" value="full"></v-radio>
                                </v-radio-group>
                              </v-layout>
                            </div>
                            <div v-else-if="type4==='text'">
                              <v-text-field single-line v-model="text4" :counter="50" maxlength="50" label="ข้อความ" style="padding-top: 0px !important;margin-bottom: 10px;"></v-text-field>
                            </div>
                            <div v-else-if="type4==='location'">
                              <v-layout class="pb-3">
                                <span style="text-align:left; color:red; font-size:12px;">*</span>
                                &nbsp;
                                <span style="text-align:left; color:grey; font-size:12px;"> ระบบจะดึงตำแหน่งที่ตั้งปัจจุบันของผู้ใช้งานไปแสดงในห้องแชทเมื่อมีการเรียกใช้งาน Bottom Menu ประเภทโลเคชัน</span>
                              </v-layout>
                            </div>
                            <div v-else-if="type4==='qrcode'">
                              <v-layout>
                                <span style="margin-top:10px; margin-right:10px">ต้องการโลเคชัน :</span>
                                <v-radio-group hide-details v-model="location4" row style="margin-top: 5px !important;">
                                  <v-radio label="ต้องการ" value="true"></v-radio>
                                  <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                </v-radio-group>
                              </v-layout>
                              <v-layout class="pt-2">
                                <span style="text-align:left; color:red; font-size:12px;">*</span>
                                &nbsp;
                                <span style="text-align:left; color:grey; font-size:12px;">ใช้สำหรับการเปิดตัวอ่านคิวอาร์โค้ด</span>
                              </v-layout>
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap class="actionTemplate" v-if="templateDetail[template-1] >= 5">
                          <v-flex xs1 sm1 md1 lg1 x1>
                            <h3>E</h3>
                          </v-flex>
                          <span class="spanStyle">รูปแบบ :</span>
                          <v-flex xs8 sm8 md8 lg8 x8>
                            <v-select :items="type_menu" v-model="type5"></v-select>
                            <div v-if="type5==='link' || type5==='link_market'">
                              <v-text-field single-line v-model="urlLink5" label="URL" style="padding-top: 0px !important;"></v-text-field>
                              <v-layout v-if="type5==='link'">
                                <span style="margin-top:10px; margin-right:10px">ต้องการข้อมูลผู้ใช้งาน :</span>
                                <!-- <i class="fas fa-info-circle iconSizeWebview" @click="dialoggetProfile = true"></i> -->
                                <v-radio-group v-model="profile5" row style="margin-top: 5px !important;">
                                  <v-radio label="ต้องการ" value="true"></v-radio>
                                  <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                </v-radio-group>
                              </v-layout>
                              <!-- ถ้าเลือกต้องการ -->
                              <v-layout v-if="profile5 === 'true'" class="typeProfile">
                                <span style="margin: auto; font-size:14px; margin-right:10px">ประเภทข้อมูล :</span>
                                <v-radio-group v-model="signtype5" row>
                                  <v-radio value="sign_share" label="share token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken= true"></i>
                                  <v-radio value="sign" label="onechat_token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true"></i>
                                </v-radio-group>
                              </v-layout>
                              <!--  -->
                            </div>
                            <div v-else-if="type5==='webview'">
                              <v-text-field single-line v-model="urlLink5" label="URL" style="padding-top: 0px !important;"></v-text-field>
                              <v-layout>
                                <span style="margin-top:10px; margin-right:10px">ต้องการข้อมูลผู้ใช้งาน :</span>
                                <!-- <i class="fas fa-info-circle iconSizeWebview" @click="dialoggetProfile = true"></i> -->
                                <v-radio-group v-model="profile5" row style="margin-top: 5px !important;">
                                  <v-radio label="ต้องการ" value="true"></v-radio>
                                  <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                </v-radio-group>
                              </v-layout>
                              <!-- ถ้าเลือกต้องการ -->
                              <v-layout v-if="profile5 === 'true'" class="typeProfile">
                                <span style="margin: auto; font-size:14px; margin-right:10px">ประเภทข้อมูล :</span>
                                <v-radio-group v-model="signtype5" row>
                                  <v-radio value="sign_share" label="share token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken= true"></i>
                                  <v-radio value="sign" label="onechat_token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true"></i>
                                </v-radio-group>
                              </v-layout>
                              <!--  -->
                              <v-layout>
                                <span style="margin-top:10px; margin-right:10px">ขนาดแสดงผล :</span>
                                <i class="fas fa-info-circle iconSizeWebview" @click="dialogSizeWebviewExample = true"></i>
                                <v-radio-group v-model="showSize5" row style="margin-top: 5px !important;">
                                  <v-radio label="Compact" value="compact"></v-radio>
                                  <v-radio label="Tall" value="tall"></v-radio>
                                  <v-radio label="Full" value="full"></v-radio>
                                </v-radio-group>
                              </v-layout>
                            </div>
                            <div v-else-if="type5==='text'">
                              <v-text-field single-line v-model="text5" :counter="50" maxlength="50" label="ข้อความ" style="padding-top: 0px !important;margin-bottom: 10px;"></v-text-field>
                            </div>
                            <div v-else-if="type5==='location'">
                              <v-layout class="pb-3">
                                <span style="text-align:left; color:red; font-size:12px;">*</span>
                                &nbsp;
                                <span style="text-align:left; color:grey; font-size:12px;"> ระบบจะดึงตำแหน่งที่ตั้งปัจจุบันของผู้ใช้งานไปแสดงในห้องแชทเมื่อมีการเรียกใช้งาน Bottom Menu ประเภทโลเคชัน</span>
                              </v-layout>
                            </div>
                            <div v-else-if="type5==='qrcode'">
                              <v-layout>
                                <span style="margin-top:10px; margin-right:10px">ต้องการโลเคชัน :</span>
                                <v-radio-group hide-details v-model="location5" row style="margin-top: 5px !important;">
                                  <v-radio label="ต้องการ" value="true"></v-radio>
                                  <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                </v-radio-group>
                              </v-layout>
                              <v-layout class="pt-2">
                                <span style="text-align:left; color:red; font-size:12px;">*</span>
                                &nbsp;
                                <span style="text-align:left; color:grey; font-size:12px;">ใช้สำหรับการเปิดตัวอ่านคิวอาร์โค้ด</span>
                              </v-layout>
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap class="actionTemplate" v-if="templateDetail[template-1] >= 6">
                          <v-flex xs1 sm1 md1 lg1 x1>
                            <h3>F</h3>
                          </v-flex>
                          <span class="spanStyle">รูปแบบ :</span>
                          <v-flex xs8 sm8 md8 lg8 x8>
                            <v-select :items="type_menu" v-model="type6"></v-select>
                            <div v-if="type6==='link' || type6==='link_market'">
                              <v-text-field single-line v-model="urlLink6" label="URL" style="padding-top: 0px !important;"></v-text-field>
                              <v-layout v-if="type6==='link'">
                                <span style="margin-top:10px; margin-right:10px">ต้องการข้อมูลผู้ใช้งาน :</span>
                                <!-- <i class="fas fa-info-circle iconSizeWebview" @click="dialoggetProfile = true"></i> -->
                                <v-radio-group v-model="profile6" row style="margin-top: 5px !important;">
                                  <v-radio label="ต้องการ" value="true"></v-radio>
                                  <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                </v-radio-group>
                              </v-layout>
                              <!-- ถ้าเลือกต้องการ -->
                              <v-layout v-if="profile6 === 'true'" class="typeProfile">
                                <span style="margin: auto; font-size:14px; margin-right:10px">ประเภทข้อมูล :</span>
                                <v-radio-group v-model="signtype6" row>
                                  <v-radio value="sign_share" label="share token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken= true"></i>
                                  <v-radio value="sign" label="onechat_token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true"></i>
                                </v-radio-group>
                              </v-layout>
                              <!--  -->
                            </div>
                            <div v-else-if="type6==='webview'">
                              <v-text-field single-line v-model="urlLink6" label="URL" style="padding-top: 0px !important;"></v-text-field>
                              <v-layout>
                                <span style="margin-top:10px; margin-right:10px">ต้องการข้อมูลผู้ใช้งาน :</span>
                                <!-- <i class="fas fa-info-circle iconSizeWebview" @click="dialoggetProfile = true"></i> -->
                                <v-radio-group v-model="profile6" row style="margin-top: 5px !important;">
                                  <v-radio label="ต้องการ" value="true"></v-radio>
                                  <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                </v-radio-group>
                              </v-layout>
                              <!-- ถ้าเลือกต้องการ -->
                              <v-layout v-if="profile6 === 'true'" class="typeProfile">
                                <span style="margin: auto; font-size:14px; margin-right:10px">ประเภทข้อมูล :</span>
                                <v-radio-group v-model="signtype6" row>
                                  <v-radio value="sign_share" label="share token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialogShareToken= true"></i>
                                  <v-radio value="sign" label="onechat_token"></v-radio>
                                  <i class="fas fa-info-circle iconTypeWebview" @click="dialoggetProfile = true"></i>
                                </v-radio-group>
                              </v-layout>
                              <!--  -->
                              <v-layout>
                                <span style="margin-top:10px; margin-right:10px">ขนาดแสดงผล :</span>
                                <i class="fas fa-info-circle iconSizeWebview" @click="dialogSizeWebviewExample = true"></i>
                                <v-radio-group v-model="showSize6" row style="margin-top: 5px !important;">
                                  <v-radio label="Compact" value="compact"></v-radio>
                                  <v-radio label="Tall" value="tall"></v-radio>
                                  <v-radio label="Full" value="full"></v-radio>
                                </v-radio-group>
                              </v-layout>
                            </div>
                            <div v-else-if="type6==='text'">
                              <v-text-field single-line v-model="text6" :counter="50" maxlength="50" label="ข้อความ" style="padding-top: 0px !important;margin-bottom: 10px;"></v-text-field>
                            </div>
                            <div v-else-if="type6==='location'">
                              <v-layout class="pb-3">
                                <span style="text-align:left; color:red; font-size:12px;">*</span>
                                &nbsp;
                                <span style="text-align:left; color:grey; font-size:12px;"> ระบบจะดึงตำแหน่งที่ตั้งปัจจุบันของผู้ใช้งานไปแสดงในห้องแชทเมื่อมีการเรียกใช้งาน Bottom Menu ประเภทโลเคชัน</span>
                              </v-layout>
                            </div>
                            <div v-else-if="type6==='qrcode'">
                              <v-layout>
                                <span style="margin-top:10px; margin-right:10px">ต้องการโลเคชัน :</span>
                                <v-radio-group hide-details v-model="location6" row style="margin-top: 5px !important;">
                                  <v-radio label="ต้องการ" value="true"></v-radio>
                                  <v-radio label="ไม่ต้องการ" value="false"></v-radio>
                                </v-radio-group>
                              </v-layout>
                              <v-layout class="pt-2">
                                <span style="text-align:left; color:red; font-size:12px;">*</span>
                                &nbsp;
                                <span style="text-align:left; color:grey; font-size:12px;">ใช้สำหรับการเปิดตัวอ่านคิวอาร์โค้ด</span>
                              </v-layout>
                            </div>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <selectTemplateDialog :dialogBottommenu="dialogBottommenu" :radioGroup="template" @closeDialogSelectTemplate="closeDialogSelectTemplate" @radio="radio" />
    <SizeWebviewExampleDialog :dialogSizeWebviewExample="dialogSizeWebviewExample" @closeDialogSizeWebviewExample="closeDialogSizeWebviewExample" />
    <HowtoGetProfileDialog :dialoggetProfile="dialoggetProfile" @closeDialoggetProfile="closeDialoggetProfile" />
    <dialogShareToken :dialogShareToken="dialogShareToken" @closeDialogshareToken="closeDialogshareToken" />
  </div>
</template>
<script>
  // import { mapState } from 'vuex'
import Vue from 'vue'
import VueQrcode from '@xkeshi/vue-qrcode'
// import $ from 'jquery'
import selectTemplateDialog from '@/components/managebot/bottommenu/dialog/select_templateDialog'
import SizeWebviewExampleDialog from '@/components/managebot/bottommenu/dialog/size_webviewDialog'
import HowtoGetProfileDialog from '@/components/managebot/bottommenu/dialog/howto_getprofileDialog'
import dialogShareToken from '@/components/managebot/bottommenu/dialog/howto_getsharetokenDialog'
Vue.component(VueQrcode.name, VueQrcode)
export default {
  data () {
    return {
      dialog: false,
      showSize: 'compact',
      showSize2: 'compact',
      showSize3: 'compact',
      showSize4: 'compact',
      showSize5: 'compact',
      showSize6: 'compact',
      inset: false,
      nameBottom: 'Menu',
      bottomMenu: 'default',
      statusRichMenu: '1',
      template: 1,
      name: '',
      nameMenu: null,
      showBasicMenu: '1',
      dialogBottommenu: false,
      dialogSizeWebviewExample: false,
      dialoggetProfile: false,
      dialogShareToken: false,
      templateDetail: [ 6, 4, 4, 3, 2, 2, 1, 3, 2, 2, 2, 1, 4],
      radioChoose: null,
      image: null,
      image2: null,
      image3: null,
      image4: null,
      image5: null,
      image6: null,
      url: null,
      url2: null,
      url3: null,
      url4: null,
      url5: null,
      url6: null,
      type: null,
      type2: null,
      type3: null,
      type4: null,
      type5: null,
      type6: null,
      profile: 'false',
      profile2: 'false',
      profile3: 'false',
      profile4: 'false',
      profile5: 'false',
      profile6: 'false',
      signtype: 'sign',
      signtype2: 'sign',
      signtype3: 'sign',
      signtype4: 'sign',
      signtype5: 'sign',
      signtype6: 'sign',
      location: 'false',
      location2: 'false',
      location3: 'false',
      location3: 'false',
      location4: 'false',
      location5: 'false',
      location6: 'false',
      nameRules: [
        v => !!v || 'โปรดใส่ชื่อหรือหัวข้อ',
        v => v.length <= 30 || 'ข้อความต้องน้อยกว่า 30 ตัวอักษร'
      ],
      nameBottomRule: [
        v => !!v || 'โปรดใส่ข้อความ',
        v => v.length <= 14 || 'ข้อความต้องน้อยกว่า 14 ตัวอักษร'
      ],
      tokenbot: '',
      token: '',
      type_menu: [
        { text: 'ลิงก์', value: 'link' },
        { text: 'เว็บวิว', value: 'webview' },
        { text: 'ข้อความ', value: 'text' }
      ],
      urlLink: '',
      urlLink2: '',
      urlLink3: '',
      urlLink4: '',
      urlLink5: '',
      urlLink6: '',
      text: '',
      text2: '',
      text3: '',
      text4: '',
      text5: '',
      text6: '',
      statusLink_market: ''
    }
  },
  methods: {
    closeDialoggetProfile (value) {
      this.dialoggetProfile = value
    },
    closeDialogshareToken (value) {
      this.dialogShareToken = value
    },
    disabledBtnCreate () {
      if (this.name && this.statusRichMenu && this.nameBottom && this.showBasicMenu) {
        if (this.template === 1) {
          return this.checktype1() || this.checktype2() || this.checktype3() || this.checktype4() || this.checktype5() || this.checktype6() || this.checkImage(6)
        } else if (this.template === 2 || this.template === 3 || this.template === 13) {
          return this.checktype1() || this.checktype2() || this.checktype3() || this.checktype4() || this.checkImage(4)
        } else if (this.template === 4 || this.template === 8) {
          return this.checktype1() || this.checktype2() || this.checktype3() || this.checkImage(3)
        } else if (this.template === 5 || this.template === 6 || this.template === 9 || this.template === 10 || this.template === 11) {
          return this.checktype1() || this.checktype2() || this.checkImage(2)
        } else if (this.template === 7 || this.template === 12) {
          return this.checktype1() || this.checkImage(1)
        } else {
          return true
        }
      } else {
        return true
      }
    },
    checkImage (number) {
      if (number === 6) {
        return (this.image === null || this.image2 === null || this.image3 === null || this.image4 === null || this.image5 === null || this.image6 === null)
      } else if (number === 4) {
        return (this.image === null || this.image2 === null || this.image3 === null || this.image4 === null)
      } else if (number === 3) {
        return (this.image === null || this.image2 === null || this.image3 === null)
      } else if (number === 2) {
        return (this.image === null || this.image2 === null)
      } else {
        return (this.image === null)
      }
    },
    checktype1 () {
      if ((this.type === 'link' || this.type === 'link_market') && this.profile && this.urlLink) {
        return false
      } else if (this.type === 'webview' && this.profile && this.showSize && this.urlLink) {
        return false
      } else if (this.type === 'text' && this.text) {
        return false
      } else if(this.type === 'location') {
        return false
      } else if(this.type === 'qrcode') {
        return false
      } else {
        return true
      }
    },
    checktype2 () {
      if ((this.type2 === 'link' || this.type2 === 'link_market') && this.profile2 && this.urlLink2) {
        return false
      } else if (this.type2 === 'webview' && this.profile2 && this.showSize2 && this.urlLink2) {
        return false
      } else if (this.type2 === 'text' && this.text2) {
        return false
      } else if(this.type2 === 'location') {
        return false
      } else if(this.type2 === 'qrcode') {
        return false
      } else {
        return true
      }
    },
    checktype3 () {
      if ((this.type3 === 'link' || this.type3 === 'link_market') && this.profile3 && this.urlLink3) {
        return false
      } else if (this.type3 === 'webview' && this.profile3 && this.showSize3 && this.urlLink3) {
        return false
      } else if (this.type3 === 'text' && this.text3) {
        return false
      } else if(this.type3 === 'location') {
        return false
      } else if(this.type3 === 'qrcode') {
        return false
      } else {
        return true
      }
    },
    checktype4 () {
      if ((this.type4 === 'link' || this.type4 === 'link_market') && this.profile4 && this.urlLink4) {
        return false
      } else if (this.type4 === 'webview' && this.profile4 && this.showSize4 && this.urlLink4) {
        return false
      } else if (this.type4 === 'text' && this.text4) {
        return false
      }else if(this.type4 === 'location') {
        return false
      } else if(this.type4 === 'qrcode') {
        return false
      } else {
        return true
      }
    },
    checktype5 () {
      if ((this.type5 === 'link' || this.type5 === 'link_market') && this.profile5 && this.urlLink5) {
        return false
      } else if (this.type5 === 'webview' && this.profile5 && this.showSize5 && this.urlLink5) {
        return false
      } else if (this.type5 === 'text' && this.text5) {
        return false
      } else if(this.type5 === 'location') {
        return false
      } else if(this.type5 === 'qrcode') {
        return false
      } else {
        return true
      }
    },
    checktype6 () {
      if ((this.type6 === 'link' || this.type6 === 'link_market') && this.profile6 && this.urlLink6) {
        return false
      } else if (this.type6 === 'webview' && this.profile6 && this.showSize6 && this.urlLink6) {
        return false
      } else if (this.type6 === 'text' && this.text6) {
        return false
      } else if(this.type6 === 'location') {
        return false
      } else if(this.type6 === 'qrcode') {
        return false
      } else {
        return true
      }
    },
    createBottomMenu () {
      // console.log(this.template)
      var uploadFile = new FormData()
      uploadFile.append('bot_id', this.tokenbot)
      uploadFile.append('create_by', this.token)
      uploadFile.append('menu_label', this.nameBottom)
      uploadFile.append('richmenu_name', this.name)
      uploadFile.append('richmenu_status', this.statusRichMenu)
      uploadFile.append('default_behavior', this.showBasicMenu)
      uploadFile.append('type_menu', this.template.toString())
      uploadFile.append('picture1', this.image, this.image.name)
      uploadFile.append('type1', this.type)
      if (this.type === 'text') {
        uploadFile.append('message1', this.text)
      } else if (this.type === 'webview') {
        uploadFile.append('url1', this.urlLink)
        uploadFile.append('size1', this.showSize)
        if (this.profile === 'true') {
          if (this.signtype === 'sign_share') {
            uploadFile.append('sign_share1', 'true')
            uploadFile.append('sign1', 'false')
          } else if (this.signtype === 'sign') {
            uploadFile.append('sign_share1', 'false')
            uploadFile.append('sign1', 'true')
          }
        } else {
          uploadFile.append('sign_share1', 'false')
          uploadFile.append('sign1', 'false')
        }
      } else if (this.type === 'link') {
        uploadFile.append('url1', this.urlLink)
        if (this.profile === 'true') {
          if (this.signtype === 'sign_share') {
            uploadFile.append('sign_share1', 'true')
            uploadFile.append('sign1', 'false')
          } else if (this.signtype === 'sign') {
            uploadFile.append('sign_share1', 'false')
            uploadFile.append('sign1', 'true')
          }
        } else {
          uploadFile.append('sign_share1', 'false')
          uploadFile.append('sign1', 'false')
        }
      } else if (this.type === 'link_market') {
        uploadFile.append('url1', this.urlLink)
        uploadFile.append('sign_share1', 'false')
        uploadFile.append('sign1', 'false')
      } else if (this.type === 'qrcode'){
        if(this.location === 'true'){
          uploadFile.append('location_status1', 'true')
        }else {
          uploadFile.append('location_status1', 'false')
        }
      }

      if (this.templateDetail[this.template - 1] >= 2) {
        uploadFile.append('picture2', this.image2, this.image2.name)
        uploadFile.append('type2', this.type2)
        if (this.type2 === 'text') {
          uploadFile.append('message2', this.text2)
        } else if (this.type2 === 'webview') {
          uploadFile.append('url2', this.urlLink2)
          uploadFile.append('size2', this.showSize2)
          if (this.profile2 === 'true') {
            if (this.signtype2 === 'sign_share') {
              uploadFile.append('sign_share2', 'true')
              uploadFile.append('sign2', 'false')
            } else if (this.signtype2 === 'sign') {
              uploadFile.append('sign_share2', 'false')
              uploadFile.append('sign2', 'true')
            }
          } else {
            uploadFile.append('sign_share2', 'false')
            uploadFile.append('sign2', 'false')
          }
        } else if (this.type2 === 'link') {
          uploadFile.append('url2', this.urlLink2)
          if (this.profile2 === 'true') {
            if (this.signtype2 === 'sign_share') {
              uploadFile.append('sign_share2', 'true')
              uploadFile.append('sign2', 'false')
            } else if (this.signtype2 === 'sign') {
              uploadFile.append('sign_share2', 'false')
              uploadFile.append('sign2', 'true')
            }
          } else {
            uploadFile.append('sign_share2', 'false')
            uploadFile.append('sign2', 'false')
          }
        } else if (this.type2 === 'link_market') {
          uploadFile.append('url2', this.urlLink2)
          uploadFile.append('sign_share2', 'false')
          uploadFile.append('sign2', 'false')
        } else if (this.type2 === 'qrcode'){
          if(this.location2 === 'true'){
            uploadFile.append('location_status2', 'true')
          }else {
            uploadFile.append('location_status2', 'false')
          }
        }
        }

      if (this.templateDetail[this.template - 1] >= 3) {
        uploadFile.append('picture3', this.image3, this.image3.name)
        uploadFile.append('type3', this.type3)
        if (this.type3 === 'text') {
          uploadFile.append('message3', this.text3)
        } else if (this.type3 === 'webview') {
          uploadFile.append('url3', this.urlLink3)
          uploadFile.append('size3', this.showSize3)
          if (this.profile3 === 'true') {
            if (this.signtype3 === 'sign_share') {
              uploadFile.append('sign_share3', 'true')
              uploadFile.append('sign3', 'false')
            } else if (this.signtype3 === 'sign') {
              uploadFile.append('sign_share3', 'false')
              uploadFile.append('sign3', 'true')
            }
          } else {
            uploadFile.append('sign_share3', 'false')
            uploadFile.append('sign3', 'false')
          }
        } else if (this.type3 === 'link') {
          uploadFile.append('url3', this.urlLink3)
          if (this.profile3 === 'true') {
            if (this.signtype3 === 'sign_share') {
              uploadFile.append('sign_share3', 'true')
              uploadFile.append('sign3', 'false')
            } else if (this.signtype3 === 'sign') {
              uploadFile.append('sign_share3', 'false')
              uploadFile.append('sign3', 'true')
            }
          } else {
            uploadFile.append('sign_share3', 'false')
            uploadFile.append('sign3', 'false')
          }
        } else if (this.type3 === 'link_market') {
          uploadFile.append('url3', this.urlLink3)
          uploadFile.append('sign_share3', 'false')
          uploadFile.append('sign3', 'false')
        } else if (this.type3 === 'qrcode'){
          if(this.location3 === 'true'){
            uploadFile.append('location_status3', 'true')
          }else {
            uploadFile.append('location_status3', 'false')
          }
        }
      }

      if (this.templateDetail[this.template - 1] >= 4) {
        uploadFile.append('picture4', this.image4, this.image4.name)
        uploadFile.append('type4', this.type4)
        if (this.type4 === 'text') {
          uploadFile.append('message4', this.text4)
        } else if (this.type4 === 'webview') {
          uploadFile.append('url4', this.urlLink4)
          uploadFile.append('size4', this.showSize4)
          if (this.profile4 === 'true') {
            if (this.signtype4 === 'sign_share') {
              uploadFile.append('sign_share4', 'true')
              uploadFile.append('sign4', 'false')
            } else if (this.signtype4 === 'sign') {
              uploadFile.append('sign_share4', 'false')
              uploadFile.append('sign4', 'true')
            }
          } else {
            uploadFile.append('sign_share4', 'false')
            uploadFile.append('sign4', 'false')
          }
        } else if (this.type4 === 'link') {
          uploadFile.append('url4', this.urlLink4)
          if (this.profile4 === 'true') {
            if (this.signtype4 === 'sign_share') {
              uploadFile.append('sign_share4', 'true')
              uploadFile.append('sign4', 'false')
            } else if (this.signtype4 === 'sign') {
              uploadFile.append('sign_share4', 'false')
              uploadFile.append('sign4', 'true')
            }
          } else {
            uploadFile.append('sign_share4', 'false')
            uploadFile.append('sign4', 'false')
          }
        } else if (this.type4 === 'link_market') {
          uploadFile.append('url4', this.urlLink4)
          uploadFile.append('sign_share4', 'false')
          uploadFile.append('sign4', 'false')
        } else if (this.type4 === 'qrcode'){
          if(this.location4 === 'true'){
            uploadFile.append('location_status4', 'true')
          }else {
            uploadFile.append('location_status4', 'false')
          }
        }
      }

      if (this.templateDetail[this.template - 1] >= 5) {
        uploadFile.append('picture5', this.image5, this.image5.name)
        uploadFile.append('type5', this.type5)
        if (this.type5 === 'text') {
          uploadFile.append('message5', this.text5)
        } else if (this.type5 === 'webview') {
          uploadFile.append('url5', this.urlLink5)
          uploadFile.append('size5', this.showSize5)
          if (this.profile5 === 'true') {
            if (this.signtype5 === 'sign_share') {
              uploadFile.append('sign_share5', 'true')
              uploadFile.append('sign5', 'false')
            } else if (this.signtype5 === 'sign') {
              uploadFile.append('sign_share5', 'false')
              uploadFile.append('sign5', 'true')
            }
          } else {
            uploadFile.append('sign_share5', 'false')
            uploadFile.append('sign5', 'false')
          }
        } else if (this.type5 === 'link') {
          uploadFile.append('url5', this.urlLink5)
          if (this.profile5 === 'true') {
            if (this.signtype5 === 'sign_share') {
              uploadFile.append('sign_share5', 'true')
              uploadFile.append('sign5', 'false')
            } else if (this.signtype5 === 'sign') {
              uploadFile.append('sign_share5', 'false')
              uploadFile.append('sign5', 'true')
            }
          } else {
            uploadFile.append('sign_share5', 'false')
            uploadFile.append('sign5', 'false')
          }
        } else if (this.type5 === 'link_market') {
          uploadFile.append('url5', this.urlLink5)
          uploadFile.append('sign_share5', 'false')
          uploadFile.append('sign5', 'false')
        } else if (this.type5 === 'qrcode'){
          if(this.location5 === 'true'){
            uploadFile.append('location_status5', 'true')
          }else {
            uploadFile.append('location_status5', 'false')
          }
        }
      }

      if (this.templateDetail[this.template - 1] === 6) {
        uploadFile.append('picture6', this.image6, this.image6.name)
        uploadFile.append('type6', this.type6)
        if (this.type6 === 'text') {
          uploadFile.append('message6', this.text6)
        } else if (this.type6 === 'webview') {
          uploadFile.append('url6', this.urlLink6)
          uploadFile.append('size6', this.showSize6)
          if (this.profile6 === 'true') {
            if (this.signtype6 === 'sign_share') {
              uploadFile.append('sign_share6', 'true')
              uploadFile.append('sign6', 'false')
            } else if (this.signtype6 === 'sign') {
              uploadFile.append('sign_share6', 'false')
              uploadFile.append('sign6', 'true')
            }
          } else {
            uploadFile.append('sign_share6', 'false')
            uploadFile.append('sign6', 'false')
          }
        } else if (this.type6 === 'link') {
          uploadFile.append('url6', this.urlLink6)
          if (this.profile6 === 'true') {
            if (this.signtype6 === 'sign_share') {
              uploadFile.append('sign_share6', 'true')
              uploadFile.append('sign6', 'false')
            } else if (this.signtype6 === 'sign') {
              uploadFile.append('sign_share6', 'false')
              uploadFile.append('sign6', 'true')
            }
          } else {
            uploadFile.append('sign_share6', 'false')
            uploadFile.append('sign6', 'false')
          }
        } else if (this.type6 === 'link_market') {
          uploadFile.append('url6', this.urlLink6)
          uploadFile.append('sign_share6', 'false')
          uploadFile.append('sign6', 'false')
        }  else if (this.type6 === 'qrcode'){
          if(this.location6 === 'true'){
            uploadFile.append('location_status6', 'true')
          }else {
            uploadFile.append('location_status6', 'false')
          }
        }
      }

      // console.log(...uploadFile)

      this.$http.post(process.env.APImanage + '/v4/create_richmenu', uploadFile).then((response) => {
        // console.log(response.body)
        if (response.body['status'] === 'success') {
          this.$swal(
            'การสร้างBottom Menu',
            'Bottom Menuถูกสร้างแล้ว.',
            'success'
          )
          this.backlink()
        }
      }, (response) => {})
    },
    checkState_market () {
      var body = {bot_id: this.tokenbot}
      this.$http.post(process.env.APImanage + '/check_rolebot', body).then((response) => {
        // console.log(response.body)
        if (response.body['status'] === 'success') {
          this.statusLink_market = true
          // this.$swal(
          //   'การสร้างBottom Menu',
          //   'Bottom Menuถูกสร้างแล้ว.',
          //   'success'
          // )
          // this.backlink()
        } else {
          this.statusLink_market = false
        }
      }, (response) => {})
    },
    backlink () {
      this.$router.go(-1)
    },
    selectTemplate () {
      this.dialogBottommenu = true
    },
    closeDialogSelectTemplate (value) {
      this.dialogBottommenu = value
    },
    closeDialogSizeWebviewExample (value) {
      this.dialogSizeWebviewExample = value
    },
    radio (radio) {
      if (radio !== this.template) {
        this.template = radio
        this.clearImage()
        this.cleardataSelect()
      }
    },
    clearImage () {
      this.url = null
      this.url2 = null
      this.url3 = null
      this.url4 = null
      this.url5 = null
      this.url6 = null
    },
    chooseImage () {
      this.$refs.fileInput.click()
    },
    chooseImage2 () {
      this.$refs.fileInput2.click()
    },
    chooseImage3 () {
      this.$refs.fileInput3.click()
    },
    chooseImage4 () {
      this.$refs.fileInput4.click()
    },
    chooseImage5 () {
      this.$refs.fileInput5.click()
    },
    chooseImage6 () {
      this.$refs.fileInput6.click()
    },
    onSelectfile (data) {
      var input = this.$refs.fileInput
      var files = input.files
      this.image = data.target.files[0]

      if (files && files[0]) {
        this.url = URL.createObjectURL(data.target.files[0])
      }
    },
    onSelectfile2 (data) {
      var input = this.$refs.fileInput2
      var files = input.files
      this.image2 = data.target.files[0]

      if (files && files[0]) {
        this.url2 = URL.createObjectURL(files[0])
      }
    },
    onSelectfile3 (data) {
      var input = this.$refs.fileInput3
      var files = input.files
      this.image3 = data.target.files[0]

      if (files && files[0]) {
        this.url3 = URL.createObjectURL(files[0])
      }
    },
    onSelectfile4 (data) {
      var input = this.$refs.fileInput4
      var files = input.files
      this.image4 = data.target.files[0]

      if (files && files[0]) {
        this.url4 = URL.createObjectURL(files[0])
      }
    },
    onSelectfile5 (data) {
      var input = this.$refs.fileInput5
      var files = input.files
      this.image5 = data.target.files[0]

      if (files && files[0]) {
        this.url5 = URL.createObjectURL(files[0])
      }
    },
    onSelectfile6 (data) {
      var input = this.$refs.fileInput6
      var files = input.files
      this.image6 = data.target.files[0]

      if (files && files[0]) {
        this.url6 = URL.createObjectURL(files[0])
      }
    },
    cleardataSelect () {
      // ฝากเขียนหน่อย
      this.showSize = 'compact'
      this.showSize2 = 'compact'
      this.showSize3 = 'compact'
      this.showSize4 = 'compact'
      this.showSize5 = 'compact'
      this.showSize6 = 'compact'
      this.type = null
      this.type2 = null
      this.type3 = null
      this.type4 = null
      this.type5 = null
      this.type6 = null
      this.profile = 'false'
      this.profile2 = 'false'
      this.profile3 = 'false'
      this.profile4 = 'false'
      this.profile5 = 'false'
      this.profile6 = 'false'
      this.urlLink = ''
      this.urlLink2 = ''
      this.urlLink3 = ''
      this.urlLink4 = ''
      this.urlLink5 = ''
      this.urlLink6 = ''
      this.text = ''
      this.text2 = ''
      this.text3 = ''
      this.text4 = ''
      this.text5 = ''
      this.text6 = ''
      this.signtype = 'sign'
      this.signtype2 = 'sign'
      this.signtype3 = 'sign'
      this.signtype4 = 'sign'
      this.signtype5 = 'sign'
      this.signtype6 = 'sign'
    }
  },
  components: {
    selectTemplateDialog,
    SizeWebviewExampleDialog,
    HowtoGetProfileDialog,
    dialogShareToken
  },
  watch: {
    bottomMenu () {
      if (this.bottomMenu === 'default') {
        this.nameBottom = 'Menu'
      }
    },
    statusLink_market () {
      if (this.statusLink_market) {
        this.type_menu = [
          { text: 'ลิงก์', value: 'link' },
          { text: 'ลิงก์ market', value: 'link_market' },
          { text: 'เว็บวิว', value: 'webview' },
          { text: 'ข้อความ', value: 'text' },
          { text: 'โลเคชัน', value: 'location' },
          { text: 'คิวอาร์โค้ด', value: 'qrcode'}
        ]
      } else {
        this.type_menu = [
          { text: 'ลิงก์', value: 'link' },
          { text: 'เว็บวิว', value: 'webview' },
          { text: 'ข้อความ', value: 'text' },
          { text: 'โลเคชัน', value: 'location' },
          { text: 'คิวอาร์โค้ด', value: 'qrcode'}
        ]
      }
    }
  },
  created () {
    this.token = localStorage.getItem('tokenuser')
    this.tokenbot = this.$route.params.tokenbot
    this.checkState_market()
  }
}
</script>
<style type="text/css" scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}

.v-card {
  border-radius: 2px;
  box-shadow: none;
  display: block;
  min-width: 0;
  position: relative;
  text-decoration: none;
  transition: .3s cubic-bezier(.25, .8, .5, 1);
}

>>>.v-menu__content .menuable__content__active {
  box-shadow: none !important;
  border-radius: 10px !important;
  border: 1px solid #656565 !important;
}

.v-messages__message {
  -ms-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;
  line-height: 2;
  overflow-wrap: break-word;
  word-break: break-word;
  word-wrap: break-word;
}

.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
  box-shadow: none !important;
  border-style: solid;
  border-width: thin;
  border-radius: 5px;
  border-color: #d2d8dd;
}

.v-text-field.v-text-field--solo .v-input__control {
  min-height: 42px !important;
  padding: 0 !important;
}

.buttonclear {
  border-style: solid !important;
  border-radius: 5px !important;
  background-color: #bdbdbd !important;
  border-color: #bdbdbd !important;
  width: 105px !important;
  box-shadow: none !important;
}

.buttoncreate {
  border-style: solid !important;
  border-radius: 5px !important;
  background-color: #2562af !important;
  /* border-color: #bdbdbd !important; */
  width: 105px !important;
  color: white !important;
  box-shadow: none !important;
}

.Kanit {
  font-family: 'Kanit', sans-serif !important;
  word-wrap: break-word;
}

>>>.v-list {
  font-family: 'Kanit', sans-serif !important;
  box-shadow: none;
}

.edit {
  font-weight: 100;
}

.inputWrapper {
  height: 32px;
  width: 90px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  /*margin-top: 5vh;*/
  /*Using a background color, but you can use a background image to represent a button*/
  /*background-color: #DDF;*/
}

.img {
  display: block;
  max-width: 230px;
  max-height: 95px;
  width: auto;
  height: auto;
}

.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}

.dialog .dialog--active .dialog--persistent {
  max-height: 107vh;
  overflow: hidden;
}

.card__text {
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;
  overflow: hidden;
}

.textbusiness {
  margin-top: 1vh;
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
  /*width: 300px;*/
}

input[type=textprofile] {
  width: 100%;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  background-color: white;
  /*background-image: url('../assets/image/group.png');*/
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 10px 10px 10px 10px;
  -webkit-transition: width 0.4s ease-in-out;
  transition: width 0.4s ease-in-out;
}

input[type=textprofile]:disabled {
  background: #cac9c9;
}

.EndpointUrl:hover .urlcopymessageapi {
  display: inline !important;
}

.urlcopymessageapi {
  display: none !important;
}

.EndpointUrl {
  display: block;
  /*color: #6D7D8D;*/
}

.header {
  display: block;
  font-size: 1.17em;
  -webkit-margin-before: 1em;
  -webkit-margin-after: 1em;
  -webkit-margin-start: 0px;
  -webkit-margin-end: 0px;
  margin: 40px 0 20px;
  padding-left: 20px;
  line-height: 1.3;
  font-weight: bold;
  font-size: 16px;
  position: relative;
  color: black !important;
}

.header::before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  width: 0;
  height: 32px;
  border-left: 4px solid #1a76d2;
}


.buttonedit {
  border: solid 1px #DEE5EC !important;
  box-sizing: border-box !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
  text-align: center;
  font-weight: 400 !important;
  text-transform: none;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.BGwhite {
  background-color: white !important;
}

.v-input--radio-group--row .v-input--radio-group__input {
  display: inline;
  flex-direction: row;
  flex-wrap: wrap;
}

div.v-input.v-input--selection-controls.v-input--radio-group.v-input--radio-group[data-v-6d08be0b][data-v-6d08be0b] {
  max-width: fit-content;
}

.theme--light.v-divider--vertical[data-v-6d08be0b] {
  border-color: rgb(87, 87, 88);
}

.v-divider--vertical {
  align-self: stretch;
  border: solid;
  border-width: 0 thin 0 0;
  display: inline-flex;
  height: inherit;
  min-height: 100%;
  max-height: 100%;
  max-width: 0;
  width: 0;
  vertical-align: text-bottom;

}

.divTextCenter {
  position: relative;
  text-align: center;
  color: #2562af;
}

.TextCenterPicture {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 50px;
}


h3 {
  display: inline-block;
  font-size: 1.17em;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 20px;
  margin-inline-end: 0px;
  font-weight: bold;
  color: #2562af;
}

.spanStyle {
  font-size: 16px;
  /*font-style: oblique;*/
  margin-top: 24px;
  margin-right: 20px;
  margin-bottom: 24px;
  margin-left: 20px;
}

.actionTemplate {
  border-radius: 8px;
  border: #656565 1px solid;
  margin-left: 16px !important;
  margin-right: 16px !important;
  margin-bottom: 16px !important;
}

.labelAssignMenu {
  font-size: 16px;
  padding-right: 18px;
  padding-left: 18px;
  padding-top: 32px;
  padding-bottom: 26px;
}

.iconSizeWebview {
  cursor: pointer;
  margin-top: 15px;
  color: #7b7b7b;
  margin-right: 10px;
}

.headerColor {
  margin-top: 10px;
  color: #2562af !important;
}

>>>.accent--text {
  color: #2562af !important;
  caret-color: #2562af !important;
}

.vertical_center {
  margin: 0px;
  top: 50%;
  transform: translateY(-50%);
}

.btnTemplate {
  border-radius: 6px !important;
  color: white !important;
  background: #0e3660 !important;
  width: 150px;
  height: 35px;
  box-shadow: none !important;
}

.iconTypeWebview {
  cursor: pointer;
  margin-top: 5px;
  color: #7b7b7b;
  margin-right: 10px;
}

>>>.v-radio {
  margin-right: 9px !important;
}

/*.typeProfile {
      border: 2px solid #2562af;
    border-radius: 10px;
    background: #2562af1f;
    padding: 5px;
}*/
.typeProfile {
  /*border: 2px solid #2562af;*/
  border-radius: 10px;
  /*background: #2562af1f;*/
  background: #a6a8ab1f;
  padding: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/managebot/bottommenu/create_bottommenu.vue